import {useState, useEffect} from "react";
import API from "../logic/API";
import {Resolution} from "../logic/FetchResolver";
import {AppDomainResponse} from "../logic/APITypes";

/** A hook for fetching an associated app domain to a specific application from the API */
function useAppDomain(appId: string) {
  const [appDomain, setAppDomain] = useState<
    AppDomainResponse & {url: string}
  >();

  const constructUrl = (id: string | undefined): string => {
    if (!id) {
      return "";
    }
    const {protocol, hostname} = window.location;
    const baseUrl =
      hostname === "localhost"
        ? "localhost:82"
        : hostname.replace("hosting.", "");
    return `${protocol}//${baseUrl}/datamarket/domains/overview/${id}`;
  };

  const getAppDomain = async () => {
    const res: Resolution<AppDomainResponse> = await API.getAppDomain(appId);
    if (res.success && res.payload) {
      const url = constructUrl(res.payload.id);
      setAppDomain({...res.payload, url});
    }
  };

  useEffect(() => {
    getAppDomain();
  }, []);

  return {appDomain};
}

export default useAppDomain;
